import {
  MODEL_BALANCE_SHEET,
  MODEL_FINANCIAL,
  MODEL_MUTATION
} from "../config";

const initialState = {
  isOpen: false,
  fetching: false,
  fetched: false,
  model: MODEL_BALANCE_SHEET,
  balanceSheetData: [],
  mutationData: [],
  financialData: [],
  treasuryData: [],
  error: null,
  organization: null
};

export const balanceSheetReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CLOSE_BALANCE_SHEET_VIEWER": {
      return initialState;
    }
    case "OPEN_BALANCE_SHEET_VIEWER": {
      return { ...state, error: null, ...action.viewer };
    }
    case "INIT_BALANCE_SHEET": {
      return {
        ...state,
        fetching: false,
        fetched: false,
        model: MODEL_BALANCE_SHEET,
        balanceSheetData: [],
        mutationData: [],
        financialData: [],
        treasuryData: [],
        error: null
      };
    }
    case "SET_BALANCE_SHEET_ORGANIZATION": {
      return { ...state, organization: action.organization };
    }
    case "SET_BALANCE_SHEET_MODEL": {
      return { ...state, model: action.model };
    }
    case "SET_BALANCE_SHEET": {
      let data =
        state.model === MODEL_BALANCE_SHEET
          ? { balanceSheetData: action.payload }
          : state.model === MODEL_MUTATION
            ? { mutationData: action.payload }
            : state.model === MODEL_FINANCIAL
              ? { financialData: action.payload }
              : { treasuryData: action.payload };
      return { ...state, ...data };
    }
    case "FETCH_BALANCE_SHEET_PENDING": {
      return {
        ...state,
        fetching: true
      };
    }
    case "FETCH_BALANCE_SHEET_FULFILLED": {
      let data =
        state.model === MODEL_BALANCE_SHEET
          ? { balanceSheetData: action.payload }
          : state.model === MODEL_MUTATION
            ? { mutationData: action.payload }
            : state.model === MODEL_FINANCIAL
              ? { financialData: action.payload }
              : { treasuryData: action.payload };
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        ...data,
        organization: action.payload && action.payload.organization
      };
    }
    case "FETCH_BALANCE_SHEET_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        fetching: false,
        //fetched: true,
        balanceSheetData: [],
        mutationData: [],
        financialData: [],
        treasuryData: [],
        error
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/balance-sheet.js